import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AmbassadorBio.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import AmbassadorSidebar from "./AmbassadorSidebar";

const AmbassadorBio = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const {slug} = useParams();

    const [isLoading, setIsLoading] = useState(true);
    const [bioDetails, setBioDetails] = useState([]);
    const [mentoredBy, setMentoredBy] = useState([]);

    useEffect(() => {
        Promise.all([
            retrieveBioDetails()
            // retrieveClientsRepresented(),
            // retrieveCertifications()
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    useEffect(() => {
        const staticData = [
            {   
                id: 1, 
                name: 'Dr Lynn Lashbrook',
                image: '/images/lynn_lashbrook.jpg',
                url: '/users/dr-lynn-lashbrook',
                position: 'SMWW President & Founder'
            }
        ];

        const ambassadorData = {
            meta_title:'Mariana Caballero Ordonez',
            picture:'/images/mariana.jpg',
            name:'Mariana Caballero Ordonez',
            ambassador_title:'SMWW Global Ambassador',
            location:'Monterrey, Mexico City , Mexico',
            sports_focus:'Boxing',
            field_education: 'Business Administration',
            field_instagram_url:'abcdef',
            field_instagram_handle:'abcdef'
        };
        //setMentoredBy(staticData);
        //setBioDetails(ambassadorData);
    }, []);

    async function retrieveBioDetails() {
        if(slug) {
            try {
                const response = await fetch(
                    app_url+'ambassador/getbiodetails?slug='+slug,
                    {
                        method: "GET",
                        headers: {
                        'Content-Type': 'application/json',
                        },
                    }
                )
                const responsedata = await response.json();
                if(responsedata.data.msg === "Success") {
                    setBioDetails(responsedata.data.result);
                    setMentoredBy(responsedata.data.mentor_details);
                }
            } catch (error) {
                console.error(error);
            }finally {
                // Set loading to false after fetch completes (success or error)
            }
        }
    }

    // async function retrieveClientsRepresented() {
    //     if(slug) {
    //         try {
    //             const response = await fetch(
    //                 app_url+'smwwagency/getclientsrepresented?slug='+slug,
    //                 {
    //                     method: "GET",
    //                     headers: {
    //                     'Content-Type': 'application/json',
    //                     },
    //                 }
    //             )
    //             const responsedata = await response.json();
    //             if(responsedata.data.msg === "Success") {
    //                 setClientsRepresented(responsedata.data.result);
    //             }
    //         } catch (error) {
    //             console.error(error);
    //         }finally {
    //             // Set loading to false after fetch completes (success or error)
    //         }
    //     }
    // }


    // async function retrieveCertifications() {
    //     if(slug) {
    //         try {
    //             const response = await fetch(
    //                 app_url+'smwwagency/getcertifications?slug='+slug,
    //                 {
    //                     method: "GET",
    //                     headers: {
    //                     'Content-Type': 'application/json',
    //                     },
    //                 }
    //             )
    //             const responsedata = await response.json();
    //             if(responsedata.data.msg === "Success") {
    //                 setCertifications(responsedata.data.result);
    //             }
    //         } catch (error) {
    //             console.error(error);
    //         }finally {
    //             // Set loading to false after fetch completes (success or error)
    //         }
    //     }
    // }

    return (
        <>
        {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="ambassador-bio-column-layout">
                <Helmet><title>{bioDetails.meta_title}</title></Helmet>
                <div className="left"></div>
                <div className="center">
                    <div className="ambassador-mentor ambassador-container-one">
                        <div className="ambassador-block">
                            <h2>Mentored By</h2>
                            <div className="view-ambassadors view-id-ambassadors">
                                <div className="view-content">
                                    {mentoredBy.map((mentor, index) => (
                                        <div className="ambassadors-wrapper img-wrapper" key={index}>
                                            <ul>
                                                <li>
                                                    <div className="views-field-picture">
                                                        <div className="field-content">
                                                            <img
                                                                className=""
                                                                // width="193px"
                                                                // height="158px"
                                                                src={mentor.image}
                                                                alt={mentor.name}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="views-field-last-name">
                                                        <div className="field-content">
                                                            <a
                                                                style={{ color: '#003c7d', fontSize: '17px' }}
                                                                href={mentor.url}
                                                            >
                                                                {mentor.name}
                                                            </a>
                                                        </div>
                                                    </div>
                                                    <div className="views-field-ambassador-biography text">
                                                        <div className="field-content">
                                                            <ul>
                                                                <li>{mentor.position}</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ambassador-newbio-container ambassador-container-two">
                        <table className="ambassador_image_section">
                            <tbody>
                                <tr>
                                    <td className="mobile-ambassador-bio-img">
                                        <div className="ambassador_image_container">
                                            <img className="ambassador-round-img" src={bioDetails.picture} />
                                        </div>
                                    </td>
                                    <td className="mobile-ambassador-bio-name">
                                        <div className="ambassador-bio-name">{bioDetails.name && bioDetails.name}</div>
                                        <div className="user_title">{bioDetails.ambassador_title && bioDetails.ambassador_title}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="ambassador-moible-hr"></div>
                        <div className="ambassador-location">
                            <div>{bioDetails.location && (<><b>Location:</b> {bioDetails.location}</>)}</div>
                        </div>
                        <div className="ambassador-sports-focus">
                            <div>{bioDetails.sports_focus && (<><b>Sport Focus:</b> {bioDetails.sports_focus}</>)}</div>
                        </div>
                        {bioDetails.qa && (
                         <div className="ambassador-qa">
                            <div dangerouslySetInnerHTML={{ __html: bioDetails.qa }}></div>
                        </div>
                        )}
                        {bioDetails.field_ambassador_biography && (
                        <><div className="ambassador-heading-wrapper">
                            <h2>Biography</h2>
                        </div>
                        <div className="ambassador-moible-hr"></div>
                            <div className="ambassador-bio-container">
                               
                            <div dangerouslySetInnerHTML={{ __html: bioDetails.field_ambassador_biography }}></div>
                            
                            </div></>
                        )}
                         {bioDetails.field_education && (
                        <>
                            <div className="ambassador-heading-wrapper">
                                <h2>Education</h2>
                            </div>
                            <div className="ambassador-moible-hr"></div>
                            <div className="ambassador-career-container">
                               <div dangerouslySetInnerHTML={{ __html: bioDetails.field_education }}></div>
                            </div>
                        </>
                        )}
                        {(bioDetails.field_instagram_url  || bioDetails.field_instagram_handle  || bioDetails.field_facebook_url  || bioDetails.field_facebook_handle 
                        || bioDetails.field_twitter_url  || bioDetails.field_user_youtube_url  || bioDetails.field_linkedin_url  || bioDetails.field_linkedin_handle ) && (
                            <>  
                                <div className="ambassador-heading-wrapper">
                                    <h2>Social Media</h2>
                                </div>
                                <div className="ambassador-moible-hr"></div>
                                <div className="mobile-ambassador-sm-container">
                                    {bioDetails.field_instagram_url && (
                                        <div className="mobile-ambassador-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                        <img src="/basic/web/images/instagram_logo_icon.png" className="social-icon" style={{width:"34px"}} />
                                            <div style={{marginLeft:"15px"}}>
                                                <div >
                                                    <a href={bioDetails.field_instagram_url}>{bioDetails.field_instagram_handle}</a>
                                                </div>  
                                            </div>
                                        </div>
                                    )}
                                    {bioDetails.field_twitter_url && (
                                        <div className="mobile-ambassador-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                        <img src="/basic/web/images/twitter_logo_icon.png" className="social-icon" style={{width:"34px"}} />
                                            <div style={{marginLeft:"15px"}}>
                                                <div >
                                                    <a href={bioDetails.field_twitter_url}>{bioDetails.field_twitter_handle}</a>
                                                </div>
                                            </div>
                                        </div>  
                                    )}
                                    {bioDetails.field_linkedin_url && (
                                        <div className="mobile-ambassador-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                            <img src="/basic/web/images/linkedin_logo_icon.png" className="social-icon" style={{width:"34px"}} />
                                            <div style={{marginLeft:"15px"}}>
                                                <div >
                                                    <a href={bioDetails.field_linkedin_url}>{bioDetails.field_linkedin_handle}</a>
                                                </div>
                                            </div>
                                        </div> 
                                    )}
                                    {bioDetails.field_facebook_url && (
                                        <div className="mobile-ambassador-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                            <img src="/basic/web/images/facebook_logo_icon.png" className="social-icon" style={{width:"34px"}} />
                                            <div style={{marginLeft:"15px"}}>
                                                <div>
                                                    <a href={bioDetails.field_facebook_url}>{bioDetails.field_facebook_handle}</a>
                                                </div>
                                        </div>
                                        </div> 
                                    )}
                                    {bioDetails.field_user_youtube_url && (
                                        <div className="mobile-ambassador-sm" style={{width:"100%",margin: "1em 0", display:"flex", alignItems:"center"}}>
                                            <img src="/basic/web/images/youtube_logo_icon.png" className="social-icon" style={{width:"34px"}} />
                                            <div style={{marginLeft:"15px"}}>
                                                <div >
                                                    <a href={bioDetails.field_user_youtube_url}>{bioDetails.field_user_youtube_handle}</a>
                                                </div>
                                            </div>
                                        </div>  
                                    )}
                                </div>    
                            </>
                        )}
                        {bioDetails.field_how_to_contact_client && (
                            <>
                                <div className="ambassador-heading-wrapper">
                                    <h2>How to Contact</h2>
                                </div>
                                <div className="ambassador-moible-hr"></div>
                                <div style={{fontSize:"15px",margin:"1em 0",marginBottom:"0px",lineHeight: "20px"}}>
                                    <div dangerouslySetInnerHTML={{ __html: bioDetails.field_how_to_contact_client }}></div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <div className="right" style={{marginLeft: "0px"}}>
                    <AmbassadorSidebar />
                </div>
            </div>
        )}
        </>
    );
};
export default AmbassadorBio;
